module.exports = __webpack_public_path__ + "img/arrow_down.32e06aec.svg";